import React, { useEffect, useState } from 'react'
import { useDispatch } from "react-redux";
import PropTypes from "prop-types"
import { Col, Form, Input, Label, Modal, ModalBody, ModalHeader, Row, FormFeedback } from 'reactstrap';
import { useFormik } from 'formik';
import {updateOrgLogo, updateUserProfilePicture} from 'store/actions';

const OnUpdateProfilePicModal = props => {
    const dispatch = useDispatch();
    const { isOpen, toggle, userEmail,page } = props;

    const validation = useFormik({
        initialValues: {
            profilePic: '',
        },
        enableReinitialize: true,
        validate: (values) => {
            const errors = {};
            if (!values.profilePic) {
                errors.profilePic = 'Please Choose Profile Pic';
            }

            return errors;
        },
        onSubmit: (values) => {
            toggle();
            const profilePic = values.profilePic;
            const data = new FormData();
            data.append('profile_picture', profilePic, profilePic.name);
            data.append('email', userEmail);
            data.append('subdomain', window.location.hostname)
            data.append('org_logo', profilePic, profilePic.name)
            if(page === "Profile") {
                dispatch(updateUserProfilePicture(data))
            }
            else if(page === "Organization"){
                dispatch(updateOrgLogo(data))
        }}
    })

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            role="dialog"
            autoFocus={true}
            centered={true}
            className="exampleModal"
            tabIndex="-1"
        >
            <div className="modal-content">
                <ModalHeader toggle={toggle}>
                    Update Profile Picture
                </ModalHeader>
                <ModalBody>
                    <Form
                        className='form-horizontal'
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                        }}
                    >
                        <Row>
                            <Col>
                                <div className="custom-flex-container">
                                    <div className="mb-3 custom-flex-item">
                                        <Label className="form-label">Profile Picture</Label>
                                        <Input
                                            name="profilePic"
                                            className="form-control"
                                            style={{backgroundColor: "transparent"}}
                                            placeholder="Upload Profile Picture"
                                            type="file"
                                            required
                                            onChange={(event) => {
                                                validation.setFieldValue("profilePic", event.currentTarget.files[0]);
                                            }}
                                            onBlur={validation.handleBlur}
                                        />
                                        {validation.touched.profilePic && validation.errors.profilePic && (
                                            <FormFeedback type="invalid">
                                                {validation.errors.profilePic}
                                            </FormFeedback>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <div className="text-end">
                                <button
                                    type="submit"
                                    className="btn btn-success save-user"
                                >
                                    Update
                                </button>
                            </div>
                        </Row>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    )
}

OnUpdateProfilePicModal.propTypes = {
    toggle: PropTypes.func,
    isOpen: PropTypes.bool,
    userPhoneNumber: PropTypes.string,
}

export default OnUpdateProfilePicModal